import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useRef, useState } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { PhotoReorder } from './PhotoReorder'

interface SelectedPhoto {
  id?: number
  file?: File
  url: string
}
interface PhotoUploadProps {
  selectedFiles: SelectedPhoto[]
  setSelectedFiles: React.Dispatch<React.SetStateAction<SelectedPhoto[]>>
  propertyId?: number
  onOrderChange?: (order: number[]) => void
}

export function PhotoUpload({
  selectedFiles,
  setSelectedFiles,
  onOrderChange,
}: PhotoUploadProps) {
  // Mensagem de erro caso ultrapasse o limite de 25 imagens
  const [errorPhotos, setErrorPhotos] = useState('')
  // Imagem que será exibida em um modal de preview
  const [previewImage, setPreviewImage] = useState<string | null>(null)

  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    const filesArray = Array.from(e.target.files)

    const existingCount = selectedFiles.length
    const totalCount = existingCount + filesArray.length

    if (totalCount > 25) {
      setErrorPhotos('Limite de 25 imagens excedido.')
      if (fileInputRef.current) fileInputRef.current.value = ''
      return
    }

    setErrorPhotos('')
    const newPhotos: SelectedPhoto[] = filesArray.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }))
    // Limita para 25 itens
    const limitedPhotos = [...selectedFiles, ...newPhotos].slice(0, 25)
    setSelectedFiles(limitedPhotos)

    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  /** Abre o modal de preview com a imagem selecionada */

  /** Fecha o modal de preview */
  const closeImagePreview = () => {
    setPreviewImage(null)
  }

  return (
    <div className="mb-6">
      <Label className="mb-2 block font-semibold text-gray-700">
        Fotos da propriedade (máximo 25)
      </Label>

      {/* Input para seleção de várias imagens de uma só vez */}
      <Input
        ref={fileInputRef}
        type="file"
        onChange={handleFileChange}
        accept="image/*"
        multiple
        className="mt-1 w-full"
      />

      {/* Mensagem de erro caso ultrapasse o limite de 25 */}
      {errorPhotos && (
        <div className="mt-2 text-sm text-red-500">{errorPhotos}</div>
      )}

      {/* Componente de reordenação */}
      <PhotoReorder
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
        onOrderChange={onOrderChange}
      />

      {/* Modal (overlay) de preview da imagem em tela cheia */}
      {previewImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
          onClick={closeImagePreview}
        >
          <div className="relative max-h-[80vh] max-w-[90vw]">
            <img
              src={previewImage}
              alt="Preview"
              className="max-h-[80vh] max-w-[90vw] object-contain"
            />
            <button
              type="button"
              onClick={closeImagePreview}
              className="absolute right-2 top-2 rounded-full bg-white p-2 text-red-500 shadow hover:bg-red-50"
              title="Fechar"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
